<div style="display: flex">
  <mat-card style="width: 100%">
    <mat-card-subtitle>
      {{ 'ProdSchedule.orderlist' | translate }}
    </mat-card-subtitle>

    @if (!isHandset()) {
      <div style="height: 500px; overflow-y: scroll">
        <table style="width: 100%" class="nospace">
          <thead>
            <tr>
              <th style="width: 70px; text-align: start" scope="col">#</th>
              <th style="width: 100px; text-align: start" scope="col">
                {{ 'ProdSchedule.prodMonth' | translate }}
              </th>
              <th style="width: 100px; text-align: start" scope="col">
                {{ 'ProdSchedule.status' | translate }}
              </th>
              <th style="width: 300px; text-align: start" scope="col">
                {{ 'ProdSchedule.product' | translate }}
              </th>
              <th style="width: 100px; text-align: start" scope="col">
                {{ 'ProdSchedule.productionQty' | translate }}
              </th>
              @for (wsId of uniqueWorkstationIds; track wsId) {
                <th style="width: 100px; text-align: start" scope="col">
                  {{
                    wsId | prodScheduleWorkstationTitle: workstationTitles
                  }}
                  (min)
                </th>
              }
              <th scope="col"></th>
            </tr>
          </thead>

          <tbody>
            @for (order of SPRINT.orders; track order.id) {
              <tr class="taskTr">
                <td (click)="openTask(order)">{{ order.id }}</td>
                <td (click)="openTask(order)">
                  {{ order | prodScheduleOrderMonth }}
                </td>
                <td (click)="openTask(order)">
                  {{ order | prodScheduleOrderStatus }}
                </td>
                <td (click)="openTask(order)">
                  {{ order.productName }}
                </td>
                <td (click)="openTask(order)">
                  {{
                    order | prodScheduleOrderQuantity | prodScheduleNumberFormat
                  }}
                </td>
                @for (wsId of uniqueWorkstationIds; track wsId) {
                  <td (click)="openTask(order)">
                    <ng-container
                      *ngIf="
                        order.id
                          | prodScheduleWorkstationTime
                            : wsId
                            : workstationLinesMap
                            : SPRINT.orders as time
                      "
                    >
                      {{ time | prodScheduleNumberFormat }}
                    </ng-container>
                  </td>
                }
                <td>
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="sprintMenu"
                    [matMenuTriggerData]="{ order: order }"
                  >
                    <mat-icon>swap_vert</mat-icon>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <!-- Mobile -->
    @if (isHandset()) {
      <mat-list>
        @for (order of SPRINT.orders; track order.id) {
          <mat-list-item>
            <div mat-line (click)="openTask(order)">
              #{{ order.id }} {{ order | prodScheduleOrderMonth }} -
              {{ order | prodScheduleOrderStatus }}
            </div>
            <div mat-line (click)="openTask(order)">
              {{ order.productName }}
            </div>
            <div mat-line (click)="openTask(order)">
              Workstations:
              @for (
                wsLine of getWorkstationLines(order.id);
                track wsLine.workstation_id
              ) {
                {{
                  wsLine.workstation_id
                    | prodScheduleWorkstationTitle: workstationTitles
                }}
                ({{ wsLine.minutes }} min),
              }
              @if (!getWorkstationLines(order.id).length) {
                <span>None</span>
              }
            </div>
            <div mat-line (click)="openTask(order)">
              Qty: {{ order | prodScheduleOrderQuantity }} - Time:
              @for (
                wsLine of getWorkstationLines(order.id);
                track wsLine.workstation_id
              ) {
                {{
                  order.id
                    | prodScheduleWorkstationTime
                      : wsLine.workstation_id
                      : workstationLinesMap
                      : SPRINT.orders
                    | prodScheduleNumberFormat
                }}
              }
            </div>
            <div>
              <button
                mat-icon-button
                [matMenuTriggerFor]="sprintMenu"
                [matMenuTriggerData]="{ order: order }"
              >
                <mat-icon>swap_vert</mat-icon>
              </button>
            </div>
            <mat-divider></mat-divider>
          </mat-list-item>
        }
      </mat-list>
    }
  </mat-card>

  <mat-card class="burndownChartCard" *ngIf="!isHandset()">
    <mat-card-subtitle>
      {{ 'ProdSchedule.prodLineChart' | translate }} - {{ SPRINT.name }}
    </mat-card-subtitle>
    <div *ngIf="!chart; else chartBlock"></div>
    <ng-template #chartBlock>
      <google-chart
        [data]="chart"
        (ready)="onChartReady($event)"
      ></google-chart>
    </ng-template>
  </mat-card>

  <mat-card
    style="width: 100%; overflow-x: auto; margin-top: 10px"
    *ngIf="isHandset()"
    (click)="burnDownChartExpand = !burnDownChartExpand"
  >
    <span>
      {{ 'ProdSchedule.prodLineChart' | translate
      }}<mat-icon>query_stats</mat-icon></span
    >
    <span>
      <mat-icon class="arrowPos" *ngIf="!burnDownChartExpand"
        >expand_more</mat-icon
      >
      <mat-icon class="arrowPos" *ngIf="burnDownChartExpand"
        >expand_less</mat-icon
      >
    </span>
    <div *ngIf="burnDownChartExpand">
      <div *ngIf="!chart; else chartBlockMobile"></div>
      <ng-template #chartBlockMobile>
        <google-chart
          [data]="chart"
          (ready)="onChartReady($event)"
        ></google-chart>
      </ng-template>
    </div>
  </mat-card>

  <mat-menu #sprintMenu="matMenu">
    <ng-template matMenuContent let-order="order">
      @for (sprint of SPRINTS; track sprint.id) {
        <button mat-menu-item (click)="moveOrderToSprint(sprint, order)">
          <mat-icon>move_down</mat-icon>{{ sprint.name }}
        </button>
      }
    </ng-template>
  </mat-menu>
</div>
